import { render } from "./StoreRedirect.vue?vue&type=template&id=3bf606cc&ts=true"
import script from "./StoreRedirect.vue?vue&type=script&lang=ts"
export * from "./StoreRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__